<template>
	<div>
		<div class="me other">
			<div class="me-info f-cb ">
				<div class="me-avatar f-img-box">
					<img :src="data.avatar?data.avatar:studentAvatar">
				</div>
				<div class="me-content">
					<div class="me-name">{{data.nick_name}}</div>
					<!--<div class="me-time">学习时长254小时</div>-->
					<div class="me-line">关注 {{data.follow_num}} <span>粉丝 {{data.fans_num}}</span></div>
					<div class="me-follow" v-if="this.$store.state.isLogin" @click="switchFollow()" :class="{'me-follow-active':data.is_follow}">关注</div>
				</div>
			</div>
			<div class="me-links">
				<div class="me-links-link me-links-link-history" @click="toOther('history')">最近学习</div>
				<div class="me-links-link me-links-link-note" @click="toOther('note')">TA的笔记</div>
				<div class="me-links-link me-links-link-lesson" @click="toOther('lesson')">TA的课程</div>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:{}
			}
		},
		created(){
			//如果是自己，跳到/me
			if(this.tools.getStorage("mooc_user_id")==this.$route.params.id){
				this.$router.replace("/me");
				return;
			}
			this.$api.get("",{
				api:"/v1/user/read",
				user_type:1,
				id:this.$route.params.id
			},res=>{
				this.data=res.data.user_info;
			})
		},
		mounted(){
			this.addActive(this.$route.path);
		},
		methods:{
			switchFollow(){
				var data=this.data;
				if(!data.is_follow){
					this.$api.get("",{
						api:"/v1/follow/followById",
						follow_id:data.id,
						user_type:this.tools.getStorage("user_type")
					},res=>{
						this.data.is_follow=1;
					})
				}
				else{
					this.$api.get("",{
						api:"/v1/follow/unfollowById",
						follow_id:data.id,
						user_type:this.tools.getStorage("user_type")
					},res=>{
						this.data.is_follow=0;
					})
				}
			},
			toOther(name){
				this.$router.replace("/other/"+name+"/"+this.$route.params.id);
			},
			addActive(path){
				["history","note","lesson"].forEach((value,index)=>{
					if(path.indexOf(value)!=-1){
						var domList=document.querySelectorAll(".me-links-link");
						domList.forEach((domValue)=>{
							domValue.className=domValue.className.replace("me-links-active","");
						})
						domList[index].className+=" me-links-active";
					}
				})
			}
		},
		watch:{
			$route(){
				this.addActive(this.$route.path);
			}
		}
	}
</script>

<style scoped>
	.me-info{
		padding:0.8rem 0.4rem 0.4rem 0.4rem;
		border-bottom:1px solid #eee;
	}
	.other .me-info{
		background: #fff;
	}
	.me-avatar{
		overflow: hidden;
		float:left;
		width:1.946rem;
		height:1.946rem;
		border:1px solid #cfcfcf;
		border-radius: 50%;
	}
	.me-content{
		position: relative;
		float:right;
		margin-top:0.133rem;
		width:6.933rem;
	}
	.me-name{
		font-size: 0.426rem;
		color:#333;
		line-height:0.426rem;
	}
	.me-time{
		margin-top:0.266rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.me-line{
		margin-top:0.4rem;
		font-size: 0.346rem;
		color:#333;
		line-height:0.346rem;
	}
	.me-line span{
		margin-left: 1.133rem;
	}
	.me-links{
		text-align: center;
		border-bottom:1px solid #eee;
	}
	.other .me-links{
		background: #fff;
	}
	.me-links-link{
		display: inline-block;
		width:2.826rem;
		padding-top:2.106rem;
		padding-bottom:0.4rem;
		text-align: center;
		background: center 0.4rem no-repeat;
		background-size: 1.44rem;
		font-size: 0.346rem;
		color:#666;
		line-height:0.346rem;
	}
	.me-links-active{
		background-color:#f2f2f2;
	}
	.me-links-link-history{
		background-image: url(../me/me-link-history.png);
	}
	.me-links-link-fav{
		background-image: url(../me/me-link-fav.png);
	}
	.me-links-link-lesson{
		background-image: url(../me/me-link-lesson.png);
	}
	.me-links-link-note{
		background-image: url(../me/me-link-note.png);
	}
	.me-follow{
		position: absolute;
		right:0;
		top:0;
		width:1.506rem;
		height:0.8rem;
		background: #ec6d3a;
		text-align: center;
		line-height:0.8rem;
		color:#fff;
		border-radius: 0.133rem;
	}
	.me-follow-active{
		background:#ccc;
		color:#fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/other/other.vue